import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import { connect } from "react-redux";
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { addToCart } from "../../store/actions/action";
import ShopProduct from '../../components/ShopProduct';
import api from "../../api";
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg';
import { useLanguage } from '../../context/LanguageContext';

const ShopPage = () => {
    const { t } = useLanguage();
    const products = api();

    return (
        <Fragment>
            <SEO title={t('pages.products')} />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.products')} pagesub={t('pages.products')} bgImage={'/banner/urunler.png'} />
            <section className="wpo-shop-page section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <ShopProduct products={products} />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default connect(null, { addToCart })(ShopPage);
